export const SEARCH_BAR_DEFAULT_PLACEHOLDER = 'Search for...';
export const FILTER_ICON_ARIA_LABEL = 'Show filters button';
